import { render, staticRenderFns } from "./FreeCenterBar.vue?vue&type=template&id=63f25a39&scoped=true"
import script from "./FreeCenterBar.vue?vue&type=script&lang=js"
export * from "./FreeCenterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f25a39",
  null
  
)

export default component.exports